export const EMPTY_ROUTE: string = "";
export const NOT_FOUND_ROUTE: string = "projects";
export const WILDCARD_ROUTE: string = "**";
